<template>
  <div class="rule-wrap">
    <h3>隐私策略</h3>
    <div class="rule-cont">
      <p><em>【特别提示】您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，饷店SaaS软件服务提供者（宁波商量信息技术有限公司或简称“我们”）制定本《隐私政策》（下称“本政策”）并提醒您。</em></p>
      <p>在注册/登录饷店SaaS软件过程中，点击同意本政策或使用饷店SaaS软件之前，请您务必仔细阅读<em>（特别是加粗并下划线的内容）</em>并透彻理解本政策，在确认充分理解并同意后使用相关产品功能。<em>一旦您开始使用饷店SaaS软件，即表示您已充分理解并同意本政策。</em></p>
      <p>如对本政策内容有任何疑问、意见或建议，您可通过宁波商量提供的各种联系方式与我们联系。</p>
      <p><em>需要特别说明的是，本政策不适用于其他第三方向您提供的服务。</em>例如第三方供应链平台依托饷店SaaS软件向您提供服务时，您向第三方供应链平台提供的个人信息不适用本政策。</p>
      <h4>第一部分 定义</h4>
      <p><em class="no_underline">一、个人信息：</em>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。单独的设备信息、搜索关键词等无法与特定个人直接建立联系的信息或数据，不属于个人信息。</p>
      <p><em>二、个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息。</em></p>
      <p><em class="no_underline">三、个人信息删除：</em>指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
      <p>四、除另有约定外，本政策所用定义与《饷店SaaS软件许可及服务协议》中的定义具有相同的涵义。</p>
      <h4>第二部分 隐私政策</h4>
      <p><em class="no_underline">一、信息收集</em></p>
      <p>在您使用饷店SaaS软件的过程中，宁波商量会按照如下方式收集您在使用饷店SaaS软件时主动提供或因为使用饷店SaaS软件功能而产生的信息，用以向您提供平台服务或优化我们的产品功能以及保障您的账号安全：</p>
      <p><em class="no_underline">1、用户注册：</em>当您注册/登录饷店SaaS软件时，为保护您账号的安全，我们收集您的手机号码并通过验证码进行身份验证；如果您选择微信登录，经您明确授权或同意后，我们将通过第三方微信收集您的微信头像、微信昵称、OpenID和UID。<em>手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。若您不提供这类信息，您可能无法正常使用我们的饷店SaaS软件功能。当您在注册时，我们会以弹窗的形式提醒您注意，在且仅在获得您的同意时将开启您的电话、短信、存储空间应用权限。电话和短信权限是为了获取并收集验证码；存储空间权限是为了实现信息和内容的本地存储和读取，便于您在使用饷店SaaS软件过程中获得良好的用户体验。</em></p>
      <p><em>2、实名认证：按照国家法律法规的规定，使用饷软件，您应当进行实名认证，我们将收集您的真实姓名、身份证信息、银行卡信息。收集上述信息是为了验证您的主体身份，保障您的交易安全和资料安全。实名认证过程中，您授权宁波商量将您的上述信息提供给第三方实名认证机构。若不提供上述信息，您将不能完整使用饷店SaaS软件功能，由此产生的损失和后果由您本人承担。</em></p>
      <p><em class="no_underline">3、资质备案：</em>按照国家法律法规的规定，为确保交易安全，作为商品交易经营者，我们会收集您的经营主体信息、联系人、联系方式、经营地址等。如不提供上述信息，您将无法完整使用饷店SaaS软件。宁波商量将通过饷店SaaS软件向您的店长或客服披露您的经营主体信息，包括但不限企业、个体工商户户主的营业执照或与营业执照相同的商事主体登记信息。您授权，根据监管部门要求、或者当您的店长或客户的向宁波商量提出请求时，宁波商量有权向其披露您的资质备案信息，包括但不限于营业执照信息、联系方式等；</p>
      <p><span>4、交易信息：</span>为了记录您的电子商务交易过程，维护消费者的合法权益，系统会自动生成订单信息，包括订单编号、订单生成时间、商品信息、支付信息等内容。上述交易信息将自动转换为第三方供应链订单，以便帮助您完成商品交易。再此过程中，饷店SaaS软件有权基于对消费者个人信息安全保护的目的，对相关信息做脱敏处理，您有可能无法查看全部信息。仅当发生售后，或其他确有必要的场景下，且经消费者授权，您将有权查看下订单全部信息。为此，您承诺对能够查看的订单信息采取保密措施，不得私自泄露、发布、买卖上述信息或将上述信息用于违法、违规等行为。</p>
      <p><em>5、优化产品功能: 当您使用饷店SaaS软件功能时，我们会收集您的设备信息（包括设备型号、操作系统版本等）和服务日志信息（包括您在宁波商量搜索或查看的信息、技术故障信息、登录IP地址、接入网络的方式类型和状态等）。</em>上述信息为系统自动获取，收集上述信息是为了保障您正常使用我们的饷店SaaS软件，维护我们饷店SaaS软件的正常运行，改进及优化我们的产品体验以及保障您的账号安全。您理解并同意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息，不属于您的个人信息。</p>
     <p><span>6、搜索：</span>当您使用饷店SaaS软件“搜索”功能时，我们会收集您的搜索记录，收集上述信息是为了便于您再次进行搜索。如您不使用“搜索”功能，我们将不会向您收集上述信息，且对您使用宁波商量无任何影响。</p>
     <p><span>7、特别约定：</span>您充分知晓，根据相关法律法规之规定，以下情形中，我们收集、使用您的个人信息无需征得您的授权同意：</p>
     <p>（1）与国家安全、国防安全有关的；</p>
     <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
     <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
     <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
     <p>（5）所收集的个人信息是您自行向社会公众公开的；</p>
     <p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
     <p>（7）根据您的要求签订合同所必需的；</p>
     <p>（8）用于维持饷店SaaS软件的安全稳定运行所必需的，例如发现、处置产品或技术故障；</p>
     <p>（9）为合法的新闻报道所必需的；</p>
     <p>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
     <p>（11）法律法规规定的其他情形。</p>
     <h4>二、信息存储</h4>
     <p>1、信息存储的地点：宁波商量会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
     <p>2、信息存储的期限：宁波商量仅在为实现目的所必需的时间内保留您的个人信息，如您注销宁波商量账户，我们将根据法律法规的规定删除您的个人信息。</p>
     <h4>三、信息使用</h4>
     <p>1、向您提供饷店SaaS软件功能（包括但不限于如下功能）:</p>
     <p>（1）使用您的手机号码登录和使用饷店SaaS软件；</p>
     <p>（2）使用您的营业资质信息、联系方式以便您的店长或消费者向您提供商品交易支持服务；</p>
     <p>2、为提高您使用饷店SaaS软件的安全性，确保操作环境安全与识别会员账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或宁波商量相关协议规则的情况。我们可能使用或整合您的信息、交易信息、设备信息、有关网络日志等，综合判断您宁波商量账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
     <p>3、我们可能会对收集的信息进行去标识化的研究、统计分析和预测，用于改善宁波商量的内容和布局，为商业决策提供数据支撑，以及改进我们的平台功能（例如使用匿名数据进行机器学习或模型算法训练）。</p>
     <h4>四、信息共享、转让和公开披露</h4>
     <p>（一）共享</p>
     <p>我们不会与饷店SaaS软件以外的第三方公司、组织和个人共享您的个人信息，但以下情况除外：</p>
     <p>1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
     <p>2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
     <p><em>3、在您主动选择情况下共享：您通过饷店SaaS软件销售商品，我们会根据您的选择，将您的信息提供给您的店长和消费者，以满足消费者的商品交易咨询和售后服务需求。</em></p>
     <p><em>4、鉴于饷店SaaS软件与第三方商品交易平台通过技术手段进行关联，如果您使用上述第三方的软件或服务，销售商品，您的销售订单信息将1对1生成采购订单共享或传输至饷店SaaS软件，销售数据同步计算、统计和展示。如您不使用上述第三方软件或服务，将不会发生您的订单信息的共享或传输。</em></p>
     <p>5、与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。</p>
     <p>6、学术研究或符合法律、法规的规定而共享等。</p>
     <p>我们会与其约定严格的数据保护措施，令其按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
     <p>（二）转让</p>
     <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
     <p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
     <p><em>2、在饷店SaaS软件发生合作、联营、合并、收购或资产转让等情形，或其他破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</em></p>
     <p>（三）公开披露</p>
     <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
     <p>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
     <p><em>2、如果我们确定您出现违反法律法规或严重违反饷店SaaS软件相关协议及规则的情况，或为保护饷店SaaS软件用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及饷店SaaS软件已对您采取的措施。</em></p>
     <p>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
     <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
     <p>1、与国家安全、国防安全有关的；</p>
     <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
     <p>3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</p>
     <p>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
     <p>5、您自行向社会公众公开的个人信息；</p>
     <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
     <p>请知悉，根据适用的法律，<em>若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</em></p>
     <p>您理解并同意，根据法律规定，共享、转让经过去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据保存及处理将无需另行向您通知并征得您的同意。</p>
     <h4>五、信息保护</h4>
     <p>1、我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。目前饷店SaaS软件和服务器使用HTTPS协议进行通信，用户敏感信息后台使用安全的单向散列算法计算并存储以确保信息不可逆，敏感信息前端展示时我们进行脱敏展示。我们也有一套数据访问控制体系确保只有授权的人才能访问个人信息，我们有建立完整的入侵监控和防御体系及时对可能的攻击做出响应。</p>
     <p>2、我们有完善的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性，我们也会定期举办信息安全培训课程加强员工的安全意识。</p>
     <p>3、我们会采取合理可行的措施，尽力避免收集无关的个人信息。<em>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。</em>例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。</p>
     <p>4、互联网并非绝对安全的环境，使用饷店SaaS软件时，<em>我们强烈建议您不要使用非饷店SaaS软件推荐的通信方式发送您的信息。</em>您可以通过饷店SaaS软件建立联系和相互分享。当您通过饷店SaaS软件创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</p>
     <p>5、在使用饷店SaaS软件进行商品交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如<em>联络方式</em>或<em>联系地址</em>。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联系宁波商量客服，以便我们根据您的申请采取相应措施</p>
     <p>6、您在使用饷店SaaS软件时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用饷店SaaS软件时共享甚至公开分享相关信息。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
     <p>7、我们会定期对公司对外提供的平台功能进行安全测试并及时修复发现的安全问题。</p>
     <p>8、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
    <h4>六、信息管理</h4>
    <p>您可以通过以下方式访问及管理您的信息：</p>
    <p>1、查询您的信息</p>
    <p>您有权查询您的信息。您可以通过以下方式自行进行：</p>
    <p>账户信息—您可以登陆账号并通过“饷店-店铺设置”访问并查询您的店铺基本资料信息，包括店铺名称、logo、微信二维码等；</p>
    <p>订单信息—您可以登录账号并通过“饷店-订单中心”访问或查询您的订单记录、交易记录等；</p>
    <p>如果您无法通过上述路径查询该等信息，您可以随时通过饷店客服与我们取得联系。我们将在15天内回复您的访问请求。</p>
    <p>2、更正或补充您的信息</p>
    <p>当您发现我们处理的关于您的信息有错误时，您有权要求我们做出更正或补充。您可以通过“1、查询您的信息”中列明的方式提出更正或补充申请。</p>
    <p>3、删除您的信息</p>
    <p>您可以通过“1、查询您的信息”中列明的方式删除您的部分信息。</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>（1）如果我们处理个人信息的行为违反法律法规；</p>
    <p>（2）如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
  <p>（3）如果我们处理个人信息的行为严重违反了与您的约定；</p>
  <p>（4）如果您不再使用我们的饷店SaaS软件，或您主动注销了账号。</p>
  <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</p>
  <p><em>当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</em></p>
  <h4>4、注销您的账户</h4>
  <p>您可以自行在“我的-账户设置-设置-注销账户”页面提交账户注销申请。 在您主动注销账户之后，我们将停止为您提供饷店SaaS软件的产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
<h4>5、约束信息系统自动决策</h4>
<p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害宁波商量商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。</p>
<h4>6、响应您的上述请求</h4>
<p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
<p>我们将在15天内做出答复。如您不满意，还可以通过饷店客服发起投诉。</p>
<p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。</p>
<p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
<p>（1）与国家安全、国防安全有关的；</p>
<p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
<p>（3）与犯罪侦查、起诉、审判和执行判决等有关的；</p>
<p>（4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
<p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
<p>（6）涉及商业秘密的。</p>
<h4>七、未成年人信息保护</h4>
<p><em>1、在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用饷店SaaS软件或向我们提供信息。</em></p>
<p>2、对于经父母或监护人同意使用饷店SaaS软件而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
<h4>八、本隐私权政策如何更新</h4>
<p>我们的隐私权政策可能变更,未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在<em>专门页面</em>上发布对隐私权政策所做的任何变更。</p>
<p>对于重大变更，我们还会提供更为显著的通知（包括我们会通过宁波商量公示的方式进行通知甚至向您提供弹窗提示）。</p>
<p>本政策所指的重大变更包括但不限于：</p>
<p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
<p>2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；</p>
<p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
<p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
<h4>九、如何联系我们</h4>
<p>您可以通过以下方式与我们联系，我们将在15天内回复您的请求：</p>
<p>1、如对本政策内容有任何疑问、意见或建议，您可通过宁波商量客服与我们联系；</p>
<p>2、我们还设立了个人信息保护专职部门，您可以通过邮箱：security@aikucun.com与我们联系。</p>
<p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</p>
<h4>十、其他</h4>
<p>1、条款的独立性</p>
<p>如果根据适用的法律认定本政策中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性，这种无效、违法或者不具有可执行性不影响本政策中的任何其它条款或者这些条款中的任何其它部分的效力。</p>
<p>2、生效时间</p>
<p>本政策于2020年1月15日进行公示，自2020年1月22日起生效。</p>
</div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="less">
  .rule-wrap {
    width: 100%;
    padding-bottom: 90px;
    overflow: auto;
    h3 {
      font-size:36px;
      font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
      font-weight:800;
      color:rgba(43,46,51,1);
      line-height:50px;
      padding: 60px 0 30px;
    }
    .rule-cont {
      background:rgba(247,247,247,1);
      width: 1000px;
      margin: 0 auto;
      padding: 55px 60px;
      font-size:16px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(43,46,51,1);
      line-height:29px;
      .underline{
         text-decoration: underline;
         text-align: left;
      }
      .no_underline{
        text-decoration:none;
      }
      p {
        text-align: left;
      }
      em {
        font-style: normal;
        text-decoration: underline;
        color: #2B2E33;
        font-family:PingFangSC-Medium;
        font-weight: bold;
      }
      span, h4 {
        color: #2B2E33;
        font-weight: bold;
      }
      h4 {
        text-align: left;
        margin-top: 35px;
      }
    }
  }
</style>
